/**
 * FE-S3b — render GET /federation/metrics + /federation/tenants as structured tables.
 */

/**
 * @param {unknown} v
 * @returns {string}
 */
function cell(v) {
  if (v == null || v === "") return "—";
  return String(v);
}

/** Format epoch ms for operator tables (never dump raw integers). */
function formatUpdatedMs(ms) {
  const n = Number(ms);
  if (!Number.isFinite(n) || n <= 0) return "—";
  try {
    return new Date(n).toLocaleString();
  } catch {
    return "—";
  }
}

/**
 * @param {Record<string, unknown>} metricsPack — API body `{ item: {...} }` or flat item
 * @param {Record<string, unknown>} tenantsPack — API body `{ items, count }`
 * @param {{ escapeHtml: (s: unknown) => string }} deps
 * @returns {string}
 */
export function buildFederationTablesHtml(metricsPack, tenantsPack, deps) {
  const esc = deps && typeof deps.escapeHtml === "function" ? deps.escapeHtml : (s) => String(s ?? "");
  const mRoot = metricsPack && typeof metricsPack === "object" ? metricsPack : {};
  const item =
    mRoot.item && typeof mRoot.item === "object"
      ? mRoot.item
      : mRoot.federation_id != null || mRoot.tenant_count != null
        ? mRoot
        : {};
  const tRoot = tenantsPack && typeof tenantsPack === "object" ? tenantsPack : {};
  const items = Array.isArray(tRoot.items) ? tRoot.items : [];
  const count = tRoot.count != null ? tRoot.count : items.length;

  const metricRows = [
    ["Network ID", item.federation_id],
    ["Organizations", item.tenant_count],
    ["Devices", item.device_total],
    ["Alarms", item.alarm_count],
    ["Avg alarm rate", item.avg_alarm_rate],
    ["Avg response (ms)", item.avg_response_ms],
    ["Avg fault rate", item.avg_fault_rate],
  ]
    .map(
      ([lab, val]) =>
        `<div class="ops-fcm-mig-row"><dt>${esc(lab)}</dt><dd class="mono">${esc(cell(val))}</dd></div>`,
    )
    .join("");

  const tenantRows = items
    .map((t) => {
      const row = t && typeof t === "object" ? t : {};
      return `<tr>
        <td class="mono">${esc(cell(row.tenant_id || row.id))}</td>
        <td class="mono">${esc(cell(row.device_total))}</td>
        <td class="mono">${esc(cell(row.alarm_count))}</td>
        <td class="mono">${esc(cell(row.alarm_rate))}</td>
        <td class="mono">${esc(cell(row.avg_response_ms))}</td>
        <td class="mono">${esc(cell(row.fault_rate))}</td>
        <td>${esc(formatUpdatedMs(row.updated_at_ms))}</td>
      </tr>`;
    })
    .join("");

  return `<h3>Network health</h3>
    <p class="muted">Cross-site coordination snapshot</p>
    <div class="ops-fcm-mig-col" style="margin-bottom:14px">
      <dl class="ops-fcm-mig-dl">${metricRows || `<div class="ops-fcm-mig-row"><dt>—</dt><dd class="mono">—</dd></div>`}</dl>
    </div>
    <h3>Organizations</h3>
    <p class="muted">${esc(String(count))} organization(s)</p>
    <table class="table">
      <thead><tr>
        <th>Organization</th><th>Devices</th><th>Alarms</th><th>Alarm rate</th><th>Avg response (ms)</th><th>Fault rate</th><th>Updated</th>
      </tr></thead>
      <tbody>${tenantRows || `<tr><td colspan="7" class="muted">No organizations.</td></tr>`}</tbody>
    </table>`;
}
